import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { AppRoutes, AppSettings } from '../configs';
import { useSelector } from 'react-redux';
import AccountSignUp from '../components/User/AccountSignUp';
import appRoutes from '../configs/AppRoutes';

const DefaultLayout = (props) => {
  const location = useLocation();
  const currentRouteName = location.pathname;
  const navigate = useNavigate();
  const { isLoggedIn, isAdmin } = useSelector((state) => state.common);
  const imageUrl = AppSettings.react_app_endpoint + '/assets/media/misc/auth-bg.png';
  const divStyle = {
    backgroundImage: `url(${imageUrl})`,
    backgroundSize: 'cover', // You can adjust these properties based on your needs
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  };
  useEffect(() => {
    // Redirect If User loggedin and currect route is not belongs to below ones 
    if (isLoggedIn) {
      return navigate(isAdmin ? AppRoutes.adminDashboardRoute : AppRoutes.dashboardRoute);
    }

  }, [isLoggedIn]);

  return (
    currentRouteName == '/user/aa' || currentRouteName == '/user/register'
      ?
      <div className="d-flex flex-root">
        <Outlet />
      </div>
      :
      <div className="d-flex flex-column flex-root min-100-vh">
        <div className="d-flex flex-column flex-lg-row flex-column-fluid">

          <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-5 p-md-10 order-2 order-lg-1">
            {/*begin::Form*/}
            <div className="d-flex flex-center flex-column flex-lg-row-fluid">
              {/*begin::Wrapper*/}
              <div className={`${currentRouteName == '/user/multi-step-form' ? 'w-100' : 'w-lg-500px p-lg-10 w-100'}`}>
                <Outlet />
              </div>
            </div>
          </div>
          {
            currentRouteName == '/user/multi-step-form'
              ?
              null
              :
              < div className="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center login-image-right order-1 order-lg-2 mb-5 mb-lg-0" style={divStyle} >
                {/*begin::Content*/}
                <div className="d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100">
                  {/*begin::Logo*/}
                  <a href={undefined} onClick={() => navigate(appRoutes.homePageRoute)} className="mb-0 mb-lg-12">
                    <img alt="Logo" src={AppSettings.react_app_endpoint + '/assets/home/logo.png'} className="h-60px h-lg-75px d-none d-lg-block" />
                    <img alt="Logo" src={AppSettings.react_app_endpoint + '/Logo-iQuote-black.png'} className="h-60px h-lg-75px d-lg-none" />
                  </a>
                  {/*end::Logo*/}
                  {/*begin::Image*/}
                  <img className="d-none d-lg-block mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20" src={AppSettings.react_app_endpoint + '/front-img.png'} alt="" />
                  {/*end::Image*/}
                  {/*begin::Title*/}
                  <h1 className="d-none d-lg-block text-white fs-2qx fw-bolder text-center mb-7">Fast, Efficient and Productive</h1>
                  {/*end::Title*/}
                </div>
                {/*end::Content*/}
              </div>
          }
        </div>
      </div >
  );
};

export default DefaultLayout;
